// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"styles_checkbox__L5Q8V","checkboxChecked":"styles_checkboxChecked__3WB_W"};